import { observer } from 'mobx-react-lite';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { ListDate } from 'services/commonDate_services';
import * as rootStore from 'stores/root_store';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import {
  BC07DataChart,
  DetailTimeMachineTroubledReport,
  ListKeynValue,
  TimeMachineHasTroubled,
} from 'services/report_services';
import moment from 'moment';
import CustomSelect from 'base/ui/components/CustomSelect';
import { Button, DatePicker, Empty, Form, Modal, Radio, RadioChangeEvent } from 'antd';
import { EChartsOption } from 'echarts';
import ReactECharts from 'echarts-for-react';
import { formatNumber } from 'utils/formatHelper';
import { BC07ColumnModel } from './model';
import { ProColumns } from '@ant-design/pro-table';
import CustomProTable from 'base/ui/components/CustomTable';
import SaveReportForm from '../reportComponents/reportForm';
import { ColumnType } from 'antd/es/table';
import { TypeColumnsBase, TypeColumnsSystem, TypeColumnsUser } from '../BC8WorkOrderFinished/model';
import { ActionType, ColumnsState } from '@ant-design/pro-components';
import TemplateReportModal from 'base/ui/components/Modal/TemplateReportModal';
import SearchCollapse from '../reportComponents/searchCollapse';
import Wrapper from 'base/ui/components/Wrapper';
import { defaultColumnsState } from 'utils/reportHelper';
import dayjs from 'dayjs';
import { debounce } from 'lodash';

export function createMachineBreakdownTime() {
  return observer(() => {
    //=======================================================================
    //======================================================================= REGISTER VARIALBE ZONE
    //=======================================================================
    //-----SEARCH AND LIST DATA-------------------------------------------------------------------------------------------- //
    const [dataSearch, setDataSearch] = useState({
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        orderBy: '',
        orderByDesc: '',
      },
      workShopId: undefined as string | undefined,
      equipmentName: [] as string[],
      fromTime: undefined as string | undefined,
      toTime: undefined as string | undefined,
      isGreaterThan0: true,
    });
    // lay danh sach date tu API
    const [commonDate, setCommonDate] = useState<ListDate[]>([]);
    //lay picked date
    const [pickedDate, setpickedDate] = useState<string>('ThisMonth');
    // Kiểm tra call xong  api lấy ngày picked date
    const [isReady, setIsReady] = useState(false);

    // danh sach phan xuong
    // list workshop danh sach phan xuong
    const [listWS, setListWS] = useState<ListKeynValue[]>([]);
    // load equipment name
    const [listEquip, setListEquip] = useState<ListKeynValue[]>([]);
    const [dataChart, setDataChart] = useState<BC07DataChart>();
    const [dataTable, setDataTable] = useState<BC07ColumnModel[]>([]);
    // details on popup
    const [dataDetailsAPI, setDataDetailsAPI] = useState<DetailTimeMachineTroubledReport>();
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    // Form validation-----------------------------------
    const { register, handleSubmit } = useForm<String>();

    //loading page when reload
    const [isLoading, setIsLoading] = useState(true);
    // OPEN POP UP DIALOG
    const [open, setOpen] = useState(false);
    // check chuyen gio sang phut
    const setBGColorChart = ['#FFE699', '#F4B183', '#9DC3E6', '#FF8989', '#C9C9C9'];

    //   Option của chart
    var option: EChartsOption = {
      color: setBGColorChart,
      tooltip: {
        trigger: 'axis',

        textStyle: {
          fontFamily: 'inherit',
          fontSize: 13,
        },
        borderRadius: 3,
        borderWidth: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 1,
        shadowBlur: 3,
        shadowColor: 'rgba(0, 0, 0, 0.25)',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#DFDBD6',
            color: 'black',
            fontFamily: 'Roboto',
            fontSize: 13,
            fontWeight: 400,
          },
        },
      },
      legend: {
        textStyle: {
          fontFamily: 'Roboto',
          fontSize: 13,
          color: 'black',
          fontWeight: 'bold',
        },
        right: '2%',
      },
      label: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',

        data: dataChart ? dataChart.labels : [],
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 13,
          fontFamily: 'Roboto',
          fontWeight: 400,
          color: '#77838F',
          lineHeight: 12,
          hideOverlap: false,
          interval: 0,
          rotate: 30,
        },
      },
      yAxis: [
        {
          type: 'value',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#F2F2F2',
            },
          },
          axisTick: {
            show: false,
          },
          nameTextStyle: {
            color: '#000',
          },
          axisLabel: {
            fontSize: 13,
            fontFamily: 'Roboto',
            fontWeight: 400,
            color: '#77838F',
            lineHeight: 12,
          },
        },
        {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#F2F2F2',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            fontSize: 13,
            fontFamily: 'Roboto',
            fontWeight: 400,
            color: '#77838F',
            lineHeight: 12,
          },
        },
      ],

      //   {
      //     name: countEnquririesByDemand.length ? countEnquririesByDemand[0].type : '',
      //     type: 'bar',
      //     stack: 'one',
      //     tooltip: {
      //       valueFormatter: function (value) {
      //         return formatNumber(value as number, 0) + '';
      //       },
      //     },
      //     label: {
      //       show: true,
      //       position: 'inside',
      //       valueAnimation: true,
      //       fontFamily: 'Roboto',
      //       fontSize: 13,
      //       fontWeight: 500,
      //       color: 'white',
      //       formatter: function (value) {
      //         return value.data ? formatNumber(value.data as number, 0) + '' : '';
      //       },
      //     },
      //     // data: [292, 952, 320],
      //     data: countEnquririesByDemand.length
      //       ? countEnquririesByDemand.filter((v) => v.type === countEnquririesByDemand[0].type).map((i) => i.value)
      //       : [],
      //   },
      //   {
      //     name: countEnquririesByDemand.length ? countEnquririesByDemand[1].type : '',
      //     type: 'bar',
      //     stack: 'one',
      //     tooltip: {
      //       valueFormatter: function (value) {
      //         return formatNumber(value as number, 0) + '';
      //       },
      //     },
      //     label: {
      //       show: true,
      //       position: 'inside',
      //       valueAnimation: true,
      //       fontFamily: 'Roboto',
      //       fontSize: 13,
      //       fontWeight: 500,
      //       color: 'black',
      //       formatter: function (value) {
      //         return value.data ? formatNumber(value.data as number, 0) + '' : '';
      //       },
      //     },
      //     // data: [292, 952, 320],
      //     data: countEnquririesByDemand.length
      //       ? countEnquririesByDemand.filter((v) => v.type === countEnquririesByDemand[1].type).map((i) => i.value)
      //       : [],
      //   },
      //   {
      //     name: countEnquririesByDemand.length ? countEnquririesByDemand[2].type : '',
      //     type: 'bar',
      //     stack: 'one',
      //     tooltip: {
      //       valueFormatter: function (value) {
      //         return formatNumber(value as number, 0) + '';
      //       },
      //     },
      //     label: {
      //       show: true,
      //       position: 'inside',
      //       valueAnimation: true,
      //       fontFamily: 'Roboto',
      //       fontSize: 13,
      //       fontWeight: 500,
      //       color: 'black',
      //       formatter: function (value) {
      //         return value.data ? formatNumber(value.data as number, 0) + '' : '';
      //       },
      //     },
      //     // data: [292, 952, 320],
      //     data: countEnquririesByDemand.length
      //       ? countEnquririesByDemand.filter((v) => v.type === countEnquririesByDemand[2].type).map((i) => i.value)
      //       : [],
      //   },
      //   {
      //     type: 'bar',
      //     stack: 'one',
      //     barMinHeight: 5,
      //     tooltip: {
      //       show: false,
      //     },
      //     color: 'transparent',
      //     label: {
      //       show: true,
      //       position: 'outside',
      //       valueAnimation: true,
      //       fontFamily: 'Roboto',
      //       fontSize: 13,
      //       fontWeight: 'bold',
      //       color: 'black',

      //       formatter: function (value) {
      //         const group = countEnquririesByDemand
      //           .filter((value, index, self) => index === self.findIndex((other) => value.month === other.month))
      //           .map((i) => i.total);
      //         return group[value.dataIndex] ? formatNumber(group[value.dataIndex], 0) + '' : '';
      //       },
      //     },
      //     // Lấy ra số lượng type yAxis
      //     data: countEnquririesByDemand
      //       .filter((value, index, self) => index === self.findIndex((other) => value.month === other.month))
      //       .map((i) => 1),
      //   },
      // ],
      series: dataChart
        ? dataChart.datas.map((item, index) => ({
          name: item.type,
          type: 'bar',
          stack: 'one',
          tooltip: {
            valueFormatter: function (value) {
              return formatNumber(value as number, 2) + '';
            },
          },
          label: {
            show: true,
            position: 'inside',
            valueAnimation: true,
            fontFamily: 'Roboto',
            fontSize: 13,
            fontWeight: 500,
            color: 'black',
            formatter: function (value) {
              return value.data ? formatNumber(value.data as number, 2) + '' : '';
            },
          },
          // data: [292, 952, 320],
          data: item.values,
        }))
        : [],
    };

    useEffect(() => {
      setColumn(defaultColumn);
    }, [dataSearch]);

    //=======================================================================
    //======================================================================= HANDLE ZONE
    //=======================================================================

    //========================================================================================================== //
    //----------------------------------------HÀM GET DATA DÙNG CHUNG--------------------------------------------//
    //========================================================================================================== //
    const getDateCommon = async () => {
      await rootStore.commonDatePresenter.getListCommonDate(rootStore.commonDateStore);
      if (rootStore.commonDateStore.listDate.data) setCommonDate(rootStore.commonDateStore.listDate.data);
    };

    // Lấy danh sách phân xưởng
    const getListWSName = async () => {
      await rootStore.reportPresenter.getListWorkShop(rootStore.reportStore);
      if (rootStore.reportStore.listKeynValue.isSuccess) {
        setListWS(rootStore.reportStore.listKeynValue.data);
      }
    };

    // Lấy danh sách máy/chuyền
    const getListEquipment = async (data?: object) => {
      await rootStore.reportPresenter.getBC07ListEquipcard(rootStore.reportStore, data ? data : {});
      if (rootStore.reportStore.listKeynValue.isSuccess) {
        setListEquip(rootStore.reportStore.listKeynValue.data);
      }
    };

    //debounce Lấy danh sách máy/chuyền
    const debounceListEquipcard = useCallback(debounce(getListEquipment, 300), []);

    // lấy ngày từ commonDate
    const getDateByKey = async (key: string) => {
      await rootStore.commonDatePresenter.getDataByCommonDate(rootStore.commonDateStore, key);
      if (rootStore.commonDateStore.commonDate) {
        setDataSearch({
          ...dataSearch,
          fromTime:
            rootStore.commonDateStore.commonDate.fromDate !== ''
              ? rootStore.commonDateStore.commonDate.fromDate
              : undefined,
          toTime:
            rootStore.commonDateStore.commonDate.toDate !== ''
              ? rootStore.commonDateStore.commonDate.toDate
              : undefined,
        });
      }
    };

    //=======================XXX========================XXX=========================XXX========================= //

    const handleChangeListEquip4Search = (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && Array.isArray(option)) {
        setDataSearch({
          ...dataSearch,
          equipmentName: option.map((val) => {
            return val.key;
          }),
        });
      } else {
        setDataSearch({
          ...dataSearch,
          equipmentName: [],
        });
      }
    };

    // handle search form
    const onSearch = async () => {
      setIsLoading(true);
      setDataSearch({ ...dataSearch, paging: { ...dataSearch.paging, pageIndex: 1 } });
      await getDataAPI({ ...dataSearch, paging: { ...dataSearch.paging, pageIndex: 1 } });
      setIsLoading(false);
    };

    // HANDLE CLOSE POP UP EDIT NAME
    const handleClose = () => {
      setOpen(false);
      setDataDetailsAPI(undefined);
    };
    // handle open pop up
    const handleOnClickOpen = async (id: string) => {
      // console.log(dataSearch, dataSearch.toTime);
      await rootStore.reportPresenter.getBC07DetailTimeMachineTroubledReport(
        rootStore.reportStore,
        id,
        dataSearch.fromTime,
        dataSearch.toTime,
      );

      if (
        rootStore.reportStore.DetailTimeMachineTroubledReportResponse.isSuccess &&
        rootStore.reportStore.DetailTimeMachineTroubledReportResponse.data
      ) {
        // Đổi thời gian ra giờ phút
        const data = rootStore.reportStore.DetailTimeMachineTroubledReportResponse.data.timeMachineHasTroubleds?.map(
          (item) => ({
            ...item,
            hours:
              (Math.floor(item.hours as number) > 0 ? Math.floor(item.hours as number) + ' giờ ' : '') +
              (((item.hours as number) * 60) % 60).toLocaleString(undefined, {
                maximumFractionDigits: 0,
              }) +
              ' phút',
          }),
        );
        setDataDetailsAPI({
          ...rootStore.reportStore.DetailTimeMachineTroubledReportResponse.data,
          timeMachineHasTroubleds: data,
        });
      }
      setOpen(true);
    };
    // FOR SEARCH : CẬP NHẬT THAY ĐỔI PHÂN XƯỞNG
    const handleChangeWorkShopName = async (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && !Array.isArray(option)) {
        setDataSearch({ ...dataSearch, workShopId: option.key });
        // gọi lại api lấy data máy
        getListEquipment({
          workshopId: [option.key],
        });
      } else {
        setDataSearch({ ...dataSearch, workShopId: undefined });
        getListEquipment({
          workshopId: [],
        });
      }
    };
    // xử lý sự kiện chọn thời gian
    const handleChangeListTime = async (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && !Array.isArray(option)) {
        setpickedDate(option.key);
        await getDateByKey(option.key);
      } else {
        setpickedDate('');
        setDataSearch({ ...dataSearch, fromTime: undefined, toTime: undefined });
      }
    };

    //=======================================================================
    //======================================================================= USEFFECT ZONE
    //=======================================================================

    //goi 2 api bang voi date
    useEffect(() => {
      const loadData = async () => {
        await getDateCommon();
        await getDateByKey(pickedDate);
        setIsReady(true);
        await getListWSName();
        await getListEquipment();
        // await getDataAPI();
        setIsLoading(false);
      };
      loadData();
    }, []);

    const getDataAPI = async (data = dataSearch) => {
      setDataChart(undefined);
      await rootStore.reportPresenter.getBC07TimeMachineTroubledReport(rootStore.reportStore, data);
      if (rootStore.reportStore.TimeMachineTroubledReportRespone.isSuccess) {
        // convert data
        const data: BC07ColumnModel[] = rootStore.reportStore.TimeMachineTroubledReportRespone.data.map((item) => ({
          stt: item.stt,
          equipmentCardId: item.equipmentCardId,
          workShopName: item.workShopName,
          equipmentGroup: item.equipmentGroup,
          equipmentName: item.equipmentName,
          totalTimeStop: item.totalTimeStop,

          khac: item.detaileRportTimeMachines[0].timeStop,
          hangLoi: item.detaileRportTimeMachines[1].timeStop,
          suCo: item.detaileRportTimeMachines[2].timeStop,
          choNVL: item.detaileRportTimeMachines[3].timeStop,
          baoTri: item.detaileRportTimeMachines[4].timeStop,
        }));
        setDataTable(data);
        // setDataTableAPI(rootStore.reportStore.TimeMachineTroubledReportRespone.data);
        setDataChart(rootStore.reportStore.TimeMachineTroubledReportRespone.dataChart);
        return data;
      }
      return [];
    };
    const defaultColumn: ProColumns<BC07ColumnModel>[] = [
      {
        title: 'STT',
        dataIndex: 'stt',
        width: 35,
        key: 'stt',
        onCell: (record) => {
          return {
            style: {
              textAlign: 'center',
            },
          };
        },
      },
      {
        title: 'Phân xưởng',
        dataIndex: 'workShopName',
        key: 'workShopName',
        className: '!py-1',
        // fixed: 'left',
        width: 150,
        sorter: true,
        onCell: (record) => {
          return {
            style: {},
          };
        },
      },
      {
        title: 'Nhóm máy',
        dataIndex: 'equipmentGroup',
        key: 'equipmentGroup',
        className: '!py-1',
        width: 150,
        sorter: true,
        onCell: (record) => {
          return {
            style: {},
          };
        },
      },
      {
        title: 'Máy móc/Chuyền',
        dataIndex: 'equipmentName',
        key: 'equipmentName',
        className: '!py-1',
        // fixed: 'left',
        width: 200,
        sorter: true,
        onCell: (record) => {
          return {
            style: {},
          };
        },
      },
      {
        title: 'TG ngưng máy (Giờ)',
        dataIndex: 'totalTimeStop',
        key: 'totalTimeStop',
        width: 100,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {
              textAlign: 'right',
            },
          };
        },
        render: (text, record) => formatNumber(Number(record.totalTimeStop), 2),
      },
      {
        title: 'Khác',
        dataIndex: 'khac',
        key: 'khac',
        width: 100,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {
              textAlign: 'right',
              backgroundColor: setBGColorChart[0],
            },
          };
        },
        render: (text, record) => formatNumber(Number(record.khac), 2),
      },
      {
        title: 'Hàng lỗi chờ xử lý',
        dataIndex: 'hangLoi',
        key: 'hangLoi',
        width: 100,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {
              textAlign: 'right',
              backgroundColor: setBGColorChart[1],
            },
          };
        },
        render: (text, record) => formatNumber(Number(record.hangLoi), 2),
      },
      {
        title: 'Máy gặp sự cố',
        dataIndex: 'suCo',
        key: 'suCo',
        width: 100,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {
              textAlign: 'right',
              backgroundColor: setBGColorChart[2],
            },
          };
        },
        render: (text, record) => formatNumber(Number(record.suCo), 2),
      },
      {
        title: 'Chờ NVL',
        dataIndex: 'choNVL',
        key: 'choNVL',
        width: 100,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {
              textAlign: 'right',
              backgroundColor: setBGColorChart[3],
            },
          };
        },
        render: (text, record) => formatNumber(Number(record.choNVL), 2),
      },
      {
        title: 'Máy đang bảo trì',
        dataIndex: 'baoTri',
        key: 'baoTri',
        width: 100,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {
              textAlign: 'right',
              backgroundColor: setBGColorChart[4],
            },
          };
        },
        render: (text, record) => formatNumber(Number(record.baoTri), 2),
      },
      {
        title: '#',
        dataIndex: 'view',
        key: 'view',
        width: 25,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {},
            children: '',
          };
        },
        render: (text, record) => (
          <VisibilityIcon
            onClick={(e) => handleOnClickOpen(record.equipmentCardId)}
            className="!text-sm hover:text-primary"
          />
        ),
      },
    ];
    const [columns, setColumn] = useState<ProColumns<BC07ColumnModel>[]>(defaultColumn);
    const handleResize =
      (index: number, id?: number) =>
        (e: any, { size }: any) => {
          setColumn((prevColumns) => {
            const nextColumns = [...prevColumns];
            nextColumns[index] = {
              ...nextColumns[index],
              width: size.width,
              // @ts-ignore
              children: nextColumns[index].children
                ? // @ts-ignore
                nextColumns[index].children.map((child, i) => {
                  if (id === i) {
                    return {
                      ...child,
                      width: size.width,
                    };
                  }
                  return child;
                })
                : undefined,
            };
            return nextColumns;
          });
        };

    const templateReportModalRef = useRef<any>(null);

    let resizableColumns = columns.map((col, index) => ({
      ...col,
      onHeaderCell: (column: ColumnType<BC07ColumnModel>) => ({
        width: column.width,
        onResize: handleResize(index),
      }),
    }));

    const handleColumnsStateChange = (newColumnsState: Record<string, ColumnsState>) => {
      setColumnsState(newColumnsState);
    };

    // Form item
    const [form] = Form.useForm();
    const tableRef = useRef<ActionType>();

    // Report sample data
    const [columnsState, setColumnsState] = useState<Record<string, ColumnsState>>({ stt: defaultColumnsState });

    // Data report system and user
    const [systemReports, setSystemReports] = useState<TypeColumnsSystem[]>([]);
    const [userReports, setUserReports] = useState<TypeColumnsUser[]>([]);

    // Id report selected
    const [selectedReportId, setSelectedReportId] = useState('');
    // Is first access
    const [isFirstAccess, setIsFirstAccess] = useState(true);

    // Name data save to localstorage
    const constDataName = 'bc-06';
    const [resizableColumnSelect, setResizableColumnSelect] = useState<any>([]);
    const [isResizablePresent, setIsResizablePresent] = useState(false);

    // State for TemplateReportModal component
    const templateReportModalProps = {
      constDataName,
      form,
      setIsLoading,
      columnsState,
      setColumnsState,
      resizableColumns,
      systemReports,
      setSystemReports,
      userReports,
      setUserReports,
      resizableColumnSelect,
      setResizableColumnSelect,
      isResizablePresent,
      setIsResizablePresent,
      setSelectedReportId,
    };

    // Get data table saved
    useEffect(() => {
      const getReportTemplate = async () => {
        await rootStore.reportSavedPresenter.getListReportTemplate(rootStore.reportSavedStore, constDataName);
        if (rootStore.reportSavedStore.listTemplateResponse.isSuccess) {
          const newData = rootStore.reportSavedStore.listTemplateResponse.data.map((item) => ({
            id: item.reportTemplateId,
            value: JSON.parse(item.templateString),
            title: item.reportTemplateName,
            description: item.description,
            default: item.isDefault,
            resizable: JSON.parse(item.resizable),
          }));
          setUserReports(newData);

          // Show report default in first reload
          const reportDefault = newData.find((i: TypeColumnsBase) => i.default === true);

          if (reportDefault && isFirstAccess) {
            setIsResizablePresent(true);
            setResizableColumnSelect(reportDefault.resizable);

            setColumnsState(reportDefault.value);
            setSelectedReportId(reportDefault.id);

            setIsFirstAccess(false);
          }
        }
      };
      getReportTemplate();
    }, []);

    // Change size columns report saved
    useEffect(() => {
      // Update resizable columns when isResizablePresent changes
      if (isResizablePresent) {
        setResizableColumnSelect(
          columns.map((col, index) => ({
            ...col,
            onHeaderCell: (column: ColumnType<BC07ColumnModel>) => ({
              width: column.width,
              onResize: handleResize(index),
            }),
          })),
        );
      }
    }, [columns]);

    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //-------------------------------------------TABLE POPUP-------------------------------------------------//
    //========================================================================================================== //
    const [popupColumns, setPopupColumns] = useState<ProColumns<TimeMachineHasTroubled>[]>([
      {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
        width: 30,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {},
          };
        },
      },
      {
        title: 'TG bắt đầu',
        dataIndex: 'timeStart',
        key: 'timeStart',
        width: 100,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {
              textAlign: 'center',
            },
          };
        },
        render: (text, record) => record.timeStart,
      },
      {
        title: 'TG kết thúc',
        dataIndex: 'timeEnd',
        key: 'timeEnd',
        width: 100,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: { textAlign: 'center' },
          };
        },
        render: (text, record) => record.timeEnd,
      },
      {
        title: 'Số giờ',
        dataIndex: 'hours',
        key: 'hours',
        width: 100,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {
              textAlign: 'left',
            },
          };
        },
        render: (text, record) => record.hours,
      },
      {
        title: 'Nguyên nhân',
        dataIndex: 'reasonStop',
        key: 'reasonStop',
        width: 150,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {},
          };
        },
        render: (text, record) => record.reasonStop,
      },
      {
        title: 'Ghi chú',
        dataIndex: 'description',
        key: 'description',
        width: 150,
        className: '!py-1',
        onCell: (record) => {
          return {
            style: {},
          };
        },
        render: (text, record) => record.description,
      },
    ]);
    const handleResizePopupTable =
      (index: number) =>
        (e: any, { size }: any) => {
          setPopupColumns((prevColumns) => {
            const nextColumns = [...prevColumns];
            nextColumns[index] = {
              ...nextColumns[index],
              width: size.width,
            };
            return nextColumns;
          });
        };
    //=======================XXX========================XXX=========================XXX========================= //

    //=======================================================================
    //======================================================================= RETURN ZONE
    //=======================================================================
    return (
      <div className="w-full py-3 px-5">
        <SearchCollapse title="BC06. BÁO CÁO THỜI GIAN NGƯNG MÁY">
          <form
            onSubmit={handleSubmit(onSearch)}
            className="w-full px-8 py-2 lg:grid lg:grid-cols-2 flex flex-col gap-y-2"
          >
            {/* Chọn phan xuong */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Phân xưởng"
                data={listWS}
                onChangeValue={handleChangeWorkShopName}
                idKey="phanXuong"
                showSearch
                allowClear
                placeholder="Chọn phân xưởng"
              />
            </div>

            {/* Chọn may moc / chuyen */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Máy/chuyền"
                data={listEquip}
                onChangeValue={handleChangeListEquip4Search}
                idKey="mayChuyen"
                showSearch
                allowClear
                placeholder="Chọn máy/chuyền"
                onSearch={(value) =>
                  debounceListEquipcard({
                    equipmentName: value,
                    workshopId: [dataSearch.workShopId],
                  })
                }
              />
            </div>

            {/* Chọn thoi gian */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title=" Thời gian"
                data={commonDate}
                allowClear
                value={commonDate.find((date) => date.key === pickedDate)}
                onChangeValue={handleChangeListTime}
                idKey="pickedDate"
                placeholder="Chọn khoảng thời gian"
              />
            </div>
            <div></div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row  mb-1 sm:items-center grid grid-cols-3">
              <label htmlFor="fromTime" className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Từ ngày
              </label>

              <DatePicker
                id="fromTime"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDate !== 'Custom' && pickedDate !== ''}
                value={dataSearch.fromTime ? dayjs(dataSearch.fromTime) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, fromTime: pickDate });
                }}
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row  mb-1 sm:items-center grid grid-cols-3">
              <label htmlFor="toTime" className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Đến ngày
              </label>

              <DatePicker
                id="toTime"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDate !== 'Custom' && pickedDate !== ''}
                value={dataSearch.toTime ? dayjs(dataSearch.toTime) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, toTime: pickDate });
                }}
              />
            </div>
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-black sm:text-end">Xem theo</label>
              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Radio.Group
                  onChange={(e: RadioChangeEvent) => {
                    setDataSearch({ ...dataSearch, isGreaterThan0: e.target.value });
                  }}
                  value={dataSearch.isGreaterThan0}
                >
                  <Radio className="!text-default" value={false}>
                    Tất cả
                  </Radio>
                  <Radio className="!text-default" value={true}>
                    Thời gian ngưng máy {'>'} 0
                  </Radio>
                </Radio.Group>
              </div>
            </div>

            {/* button tìm kiếm */}
            <div className="mt-2 w-full flex justify-center col-span-2">
              <Button
                type="primary"
                loading={isLoading}
                htmlType="submit"
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
              >
                Chạy báo cáo
              </Button>
            </div>
          </form>
        </SearchCollapse>

        <Wrapper>
          {/* =========== Table PO ===============*/}
          <div className="bg-slate-50 rounded-sm mb-4">
            {dataChart ? <ReactECharts className="!h-[350px]" option={option} /> : <Empty />}
          </div>
          {isReady ? (
            <CustomProTable<BC07ColumnModel>
              columns={columns}
              handleResize={handleResize}
              className="[&_td]:!text-default [&_th]:!text-default"
              isResizablePresent={isResizablePresent}
              resizableColumnSelect={resizableColumnSelect}
              loading={isLoading}
              request={async (params = {}, sort, filter) => {
                setIsLoading(true);
                const data = await getDataAPI({
                  ...dataSearch,
                  paging: {
                    ...dataSearch.paging,
                    orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                    orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  },
                });
                if (Object.values(sort).length) {
                  setDataSearch({
                    ...dataSearch,
                    paging: {
                      ...dataSearch.paging,
                      orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                      orderByDesc:
                        Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                    },
                  });
                }
                setIsLoading(false);
                return {
                  data: data,
                  success: rootStore.reportStore.TimeMachineTroubledReportRespone.isSuccess,
                };
              }}
              dataSource={dataTable.map((data) => data)}
              actionRef={tableRef} // Gán biến tham chiếu cho instance của bảng
              columnsState={{
                value: Object.keys(columnsState).length > 0 ? columnsState : undefined,
                onChange: (newColumnsState) => {
                  handleColumnsStateChange(newColumnsState);
                },
              }}
              rowKey="stt"
              pagination={{
                pageSize: dataSearch.paging.pageSize,
                total: rootStore.reportStore.TimeMachineTroubledReportRespone.recordsTotal,
                current: dataSearch.paging.pageIndex,
                responsive: true,
                pageSizeOptions: [10, 25, 50, 100],
                showSizeChanger: true,
                position: ['topRight', 'bottomRight'],
                style: { margin: '10px 0' },
                showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} mục`,
                onChange: (page, pageSize) => {
                  setDataSearch({
                    ...dataSearch,
                    paging: { ...dataSearch.paging, pageIndex: page, pageSize: pageSize },
                  });
                },
              }}
              toolBarRender={() => [
                <SaveReportForm
                  templateReportModalRef={templateReportModalRef}
                  userReports={userReports}
                  selectedReportId={selectedReportId}
                />,
              ]}
            />
          ) : (
            <CustomProTable<BC07ColumnModel>
              columns={columns}
              handleResize={handleResize}
              loading={isLoading}
              toolBarRender={() => []}
            />
          )}
          <TemplateReportModal ref={templateReportModalRef} {...templateReportModalProps} />
        </Wrapper>

        {/* pop up */}
        {/* <div className={`w-full h-screen fixed bg-modal inset-0 z-[100] ${!open && 'hidden'}`}>
          <div
            className="fixed w-auto min-w-[400px]
          bg-white top-1/2 left-1/2 -translate-y-1/2
          -translate-x-1/2 shadow-xl p-2 shadow-modal text-sm rounded border-t-2
          border-t-sky-700"
          >
            <div className="flex justify-end ">
              <button
                type="button"
                onClick={handleClose}
                className="rounded-sm text-white bg-red-400 hover:bg-red-400/90 h-[20px] w-[20px]"
              >
                <CloseIcon className="!flex !h-[20px] !w-[20px]" />
              </button>
            </div>
            <div className=" flex justify-center flex-col pb-4">
              <h3 className="uppercase text-sm text-center font-bold">Chi tiết thời gian ngưng máy</h3>
              <div className="m-3">
                <div className="text-[14px] pl-3 mb-3">
                  <i>
                    <b>Từ ngày : </b>
                    {dataSearch.fromTime ? (
                      moment(dataSearch.fromTime).format('DD/MM/YYYY')
                    ) : (
                      <span className="w-10 inline-block" />
                    )}
                    <b className="ml-4">Đến ngày : </b>
                    {dataSearch.toTime ? moment(dataSearch.toTime).format('DD/MM/YYYY') : <span className="w-10" />}
                  </i>
                </div>
                <div className="text-[14px] pl-3 mb-3">
                  <b>Phân xưởng :</b> {dataDetailsAPI?.workShopName}
                </div>
                <div className="text-[14px] pl-3">
                  <b>Máy móc/chuyền :</b> {dataDetailsAPI?.equipmentName}
                </div>
                <hr />
              </div>
              <CustomProTable<TimeMachineHasTroubled>
                columns={popupColumns}
                handleResize={handleResizePopupTable}
                rowKey={'stt'}
                dataSource={dataDetailsAPI ? dataDetailsAPI.timeMachineHasTroubleds : []}
                scroll={{ scrollToFirstRowOnChange: true }}
                pagination={false}
              />
            </div>
          </div>
        </div> */}
        <Modal
          title={<h3 className="uppercase text-sm text-center font-bold">Chi tiết thời gian ngưng máy</h3>}
          open={open}
          width={1000}
          onCancel={() => handleClose()}
          footer={<></>}
        >
          <div className=" flex justify-center flex-col pb-4">

            <div className="m-3">
              <div className="w-full grid grid-cols-2 text-[14px] pl-3 mb-3">
                <span><b>Từ ngày :</b>  {dataSearch.fromTime ? (
                  moment(dataSearch.fromTime).format('DD/MM/YYYY')
                ) : ''}</span>

                <span className="ml-4"><b>Đến ngày :</b> {dataSearch.toTime ? moment(dataSearch.toTime).format('DD/MM/YYYY') : ''} </span>

              </div>
              <div className="text-[14px] pl-3 mb-3">
                <b>Phân xưởng :</b> {dataDetailsAPI?.workShopName}
              </div>
              <div className="text-[14px] pl-3">
                <b>Máy móc/chuyền :</b> {dataDetailsAPI?.equipmentName}
              </div>
              <hr />
            </div>
            <CustomProTable<TimeMachineHasTroubled>
              columns={popupColumns}
              handleResize={handleResizePopupTable}
              rowKey={'stt'}
              dataSource={dataDetailsAPI ? dataDetailsAPI.timeMachineHasTroubleds : []}
              scroll={{ y: 300, scrollToFirstRowOnChange: true }}
              pagination={false}

            />
          </div>
        </Modal>
      </div>
    );
  });
}
